import Swiper, { Pagination, Autoplay, EffectFade, Navigation } from 'swiper';

class HomepageCarousel extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.init());
        } else {
            setTimeout(() => this.init());
        }
    }

    init() {
        // Destroy any stale Swiper instance (e.g. from a previous connectedCallback cycle)
        if (this.swiper) {
            this.swiper.destroy(true, true);
        }

        // Remove loop duplicates left behind by a stale instance
        this.querySelectorAll('.swiper-slide-duplicate').forEach(el => el.remove());

        const slideDelay = this.dataset.slideDelay || 0;
        const nextEl = this.querySelector('.swiper-button-next');
        const prevEl = this.querySelector('.swiper-button-prev');
        const paginationEl = this.querySelector('.hero-pagination');

        const swiper = new Swiper(this, {
            slidesPerView: 1,
            loop: true,
            modules: [
                Pagination,
                Autoplay,
                EffectFade,
                Navigation,
            ],
            pagination: {
                el: paginationEl,
                clickable: true,
            },
            ...(slideDelay ? {
                autoplay: {
                    delay: slideDelay || 0,
                    disableOnInteraction: false,
                },
            } : {}),
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            navigation: {
                nextEl,
                prevEl,
            },
            on: {
                slideChange() {
                    const bullets = document.querySelectorAll('.swiper-bullets');
                    if (!bullets?.length) return;

                    setTimeout(() => {
                        bullets.forEach(bullet => bullet.classList.remove('prev'));
                    }, 5300);

                    const activeBullets = document.querySelectorAll('.swiper-pagination-bullet-active');
                    if (!activeBullets?.length) return;

                    activeBullets.forEach(bullet => {
                        let prev = bullet.previousElementSibling;
                        while (prev) {
                            prev.classList.add('prev');
                            prev = prev.previousElementSibling;
                        }
                    });
                },
            }
        });
    }
}

if (!customElements.get('homepage-carousel')) customElements.define('homepage-carousel', HomepageCarousel)
